import ActionsPanel from "../../../layout/actions-panel";
import PageDescription from "../../../layout/page-description";

import {
    AcademicCapIcon,
    BanknotesIcon,
    CheckBadgeIcon,
    ClockIcon,
    ReceiptRefundIcon,
    UsersIcon,
} from "@heroicons/react/24/outline";
import PushToRemote from "./modals/push-to-remote";
import { useEffect, useState } from "react";

const actions = [
    {
        name: "Push customer to Monday",
        description: "Lets you select a customer and push them to Monday.",
        bg: "bg-teal-100 bordwer border-teal-500",
        action: (id: number) => {
            console.log("Push customer to Monda2y: " + id);
        },
        id: 1,

        icon: "fas fa-calendar fa-arrow",
        iconForeground: "text-teal-700 dark:text-teal-300",
        iconBackground: "bg-teal-100 border border-teal-500 bg-teal-50 dark:bg-teal-900",
    },
    {
        name: "Push customer to Slack",
        description: "Lets you select a customer and push them to Slack.",
        bg: "bg-teal-500",
        id: 2,
        action: (id: number) => {
            console.log("Push customer to Monday: " + id);
        },
        icon: "fa-brands fa-slack",
        iconForeground: "text-indigo-700 dark:text-indigo-300",
        iconBackground: "bg-indigo-100 border border-indigo-500  dark:bg-indigo-900",
    },
    {
        name: "Manage menus",
        description: "Lets you manage the menus.",
        bg: "bg-orange-500",
        id: 3,
        href: "/menu-admin",
        icon: "fas fa-bars",
        iconForeground: "text-orange-700 dark:text-orange-300",
        iconBackground: "bg-orange-100 border border-orange-500  dark:bg-orange-900",
    },
    {
        name: "Compare deal statuses with Monday",
        description: "Lets you compare the deal statuses in Monday with the deal statuses in the system.",
        bg: "bg-red-500",
        id: 4,
        href: "/admin/tools/compare-deals-monday",
        icon: "fas fa-handshake",
        iconForeground: "text-red-700 dark:text-red-300",
        iconBackground: "bg-red-100 border border-red-500  dark:bg-red-900",
    },
    {
        name: "Fix Missing Processflow Progress",
        description: "Allows you to compare multiple processflows and fix missing progress.",
        bg: "bg-blue-500",
        id: 8,
        href: "/admin/tools/fix-progress",
        icon: "fas fa-bug",
        iconForeground: "text-blue-700 dark:text-blue-300",
        iconBackground: "bg-blue-100 border border-blue-500  dark:bg-blue-900",
    },
    {
        name: "Get my auth token",
        description: "Retrieve your auth token for storybook",
        bg: "bg-blue-500",
        id: 9,
        href: "/admin/tools/get-auth-token",
        icon: "fas fa-code",
        iconForeground: "text-blue-700 dark:text-blue-300",
        iconBackground: "bg-blue-100 border border-blue-500  dark:bg-blue-900",
    },
    {
        name: "Stages",
        description: "Show and edit stages",
        bg: "bg-blue-500",
        id: 10,
        href: "/admin/stages",
        icon: "fas fa-boxes-stacked",
        iconForeground: "text-blue-700 dark:text-blue-300",
        iconBackground: "bg-blue-100 border border-blue-500  dark:bg-blue-900",
    },
    {
        name: "Mandates",
        description: "Upload and manage mandates",
        bg: "bg-green-500",
        id: 11,
        href: "/admin/mandates",
        icon: "fas fa-file-lines",
        iconForeground: "text-green-700 dark:text-green-300",
        iconBackground: "bg-green-100 border border-green-500  dark:bg-green-900",
    },
    {
        name: "Industries",
        description: "Manage industries",
        bg: "bg-red-500",
        id: 12,
        href: "/admin/industries",
        icon: "fas fa-building",
        iconForeground: "text-red-700 dark:text-red-300",
        iconBackground: "bg-red-100 border border-red-500  dark:bg-red-900",
    },
    {
        name: "Delete Processflow Progress",
        description: "Manage industries",
        bg: "bg-red-500",
        id: 13,
        href: "/admin/delete-pp",
        icon: "fal fa-trash",
        iconForeground: "text-yellow-700 dark:text-yellow-300",
        iconBackground: "bg-yellow-100 border border-yellow-500  dark:bg-yellow-900",
    },
    {
        name: "Date Range Picker Test",
        description: "Test the date range picker",
        bg: "bg-red-500",
        id: 14,
        href: "/admin/daterange-picker-test",
        icon: "fal fa-calendar",
        iconForeground: "text-blue-700 dark:text-blue-300",
        iconBackground: "bg-blue-100 border border-blue-500  dark:bg-blue-900",
    },
];

// function classNames(...classes: any[]) {
// return classes.filter(Boolean).join(" ");
// }

export default function AdminTools() {
    const [show, setShow] = useState(false);
    const [type, setType] = useState<"slack" | "monday">("slack");
    useEffect(() => {
        actions.forEach(function (part, index, actions) {
            if (actions[index]["id"] === 2) {
                //push to slack

                actions[index]["action"] = () => {
                    // alert("hoi");
                    setType("slack");
                    setShow(true);
                };
            }

            if (actions[index]["id"] === 1) {
                //push to Monday

                actions[index]["action"] = () => {
                    // alert("hoi");
                    setType("monday");
                    setShow(true);
                };
            }
        }, actions as any); // use arr as this
    }, []);
    return (
        <>
            <PageDescription
                title="Admin Tools"
                description="Tools for managing the site and its integration with 3rd party sites"
            />
            <ActionsPanel actions={actions} />
            {/* {show ? "Is Showing" : "Not Showing"} */}
            {/* {type} */}
            <PushToRemote close={() => setShow(false)} show={show} type={type} />
        </>
    );
}
